import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { themeFontSize, Copy } from '@elparking/components'

const mediaScreenMobile = props => `@media screen and (max-width: ${props.theme.screens.medium})`

const BannerWrapper = styled.div`
    width: 100%;
    color: #555759;
    font-size: ${themeFontSize('xxSmall')};
    padding: 16px 16px 0 16px;
    line-height: 1.5em;
    background-color: white;

    ${mediaScreenMobile} {
        display: none;
    }
`

const renderTitle = () => (
    <Copy as='span' fontWeight='book'>
        <FormattedMessage
          defaultMessage='Disfruta de nuestras ventajas.'
        />
    </Copy>
)

const renderDescription = () => (
    <FormattedMessage
      defaultMessage='Realiza pagos seguros online, cancelaciones gratuitas, factura mensual sin papel, todos tus aparcamientos en tu móvil.'
    />
)

export default (props) => (
    <BannerWrapper {...props}>
        {renderTitle()} {renderDescription()}
    </BannerWrapper>
)
